import {zapi} from '../__internal__/http-client/index.js';

import * as endpoints from './endpoints.js';

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.3+-+Channels+and+EPG+Data#2.2.3-ChannelsandEPGData-getchannelsv4
 * @param {$ZAPI.Channels.ChannelsRequest} data
 * @returns {Promise<$ZAPI.Channels.ChannelsResponseV4>}
 */
export const getChannelsV4 = ({pghash, ...data}) => zapi({
    path: `v4/cached/${pghash}/channels`,
    method: 'get',
    endpointID: endpoints.CHANNELS_V4_RECEIVED,
    data,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.3+-+Channels+and+EPG+Data#2.2.3-ChannelsandEPGData-channeldetailsv4
 * @param {$ZAPI.Channels.ChannelDetailsRequest} data
 * @returns {Promise<$ZAPI.Channels.ChannelDetailsInfoV4>}
 */
export const getChannelDetailsV4 = ({pghash, cda}) => zapi({
    path: `v4/cached/channel_details/${pghash}/${cda}`,
    method: 'get',
    endpointID: endpoints.CHANNEL_DETAILS_V4_RECEIVED,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.3+-+Channels+and+EPG+Data#2.2.3-ChannelsandEPGData-getfavorites
 * @returns {Promise<$ZAPI.Channels.FavoritesResponse>}
 */
export const getFavorites = () => zapi({
    path: 'channels/favorites',
    method: 'get',
    endpointID: endpoints.FAVORITES_RECEIVED,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.3+-+Channels+and+EPG+Data#2.2.3-ChannelsandEPGData-updatefavorites
 * @param {$ZAPI.Channels.UpdateFavoritesRequest} data
 * @returns {Promise<$ZAPI.Response.SuccessResponse>}
 */
export const updateFavorites = (data) => zapi({
    path: 'channels/favorites/update',
    method: 'post',
    endpointID: endpoints.FAVORITES_UPDATED,
    data,
});
